<template>
    <div class="actions">
        <slot name="before"></slot>
        <v-btn
                v-if="input"
                fab
                small
                color="primary"
                class="cell-action__btn"
                elevation="0"
                :to="{name: input, params: {id, sub_id: subId}}"
        >
            <v-icon dark class="fix-icon-btn">mdi-login-variant</v-icon>
        </v-btn>
        <slot name="center"></slot>
        <v-btn
                v-if="edit"
                fab
                small
                color="primary"
                class="cell-action__btn"
                elevation="0"
                :to="{name: edit, params: {id, sub_id: subId}}"
        >
            <v-icon dark class="fix-icon-btn">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
                v-if="del"
                fab
                small
                color="error"
                class="cell-action__btn"
                elevation="0"
                @click="deleteItem()"
        >
            <v-icon dark class="fix-icon-btn">mdi-close</v-icon>
        </v-btn>
        <slot name="after"></slot>
    </div>
</template>

<script>
export default {
    props: [
        'id',
        'subId',
        'edit',
        'input',
        'del'
    ],
    methods: {
        deleteItem() {
            if (!confirm(this.$t('msg.deleteQuestion'))) return;

            this.$store.dispatch(this.del, {id: this.id})
                .then(res => {
                    this.$emit('deleted', res.id);
                })
        }
    }
}
</script>

<style lang="scss">
    .actions {
        white-space: nowrap;

        .cell-action__btn {
            width: 28px;
            height: 28px;
            margin-right: 7px;

            &:last-child {
                margin-right: 0;
            }
            .v-icon {
                font-size: 18px;
            }
        }
    }
</style>